import { supabaseClient } from 'supabase'
import { DeskTabValue } from './deskTypes'

const TAB_VALUES: readonly string[] = ['ready', 'needs_a_look', 'discard', 'updates']

/**
 * The tab a candidate sits in now, for "Back to {tab}" when the candidate
 * screen is opened from a deep link with no router state. Null when the
 * candidate is off the desk (decided) or unknown: `.maybeSingle()`, so a
 * missing row is null and not an error. A tab value outside the closed four is
 * also null, never passed on as a raw string.
 */
export const queryDeskTabOf = async (applicationId: number): Promise<DeskTabValue | null> => {
  const { data, error } = await supabaseClient
    .from('desk_queue')
    .select('desk_tab')
    .eq('application_id', applicationId)
    .maybeSingle()

  if (error) {
    throw error
  }
  const tab = data?.desk_tab ?? null
  return tab !== null && TAB_VALUES.includes(tab) ? (tab as DeskTabValue) : null
}
